export default "/images/vendor/flag-icon-css/flags/1x1/ck.svg?95a616269fffa24b07797e82bb611896";